<div class="quality">
  <div class="quality__kpis" role="group" aria-live="polite">
    <app-kpi-card
      [label]="'liveDashboard.qualitaet.kpis.coverage' | translate"
      [value]="coverageValue()"
      suffix="%"
      icon="shield"
      iconColorVar="--to-green-fg"
      [sparkline]="qualitaet().anforderungsAbdeckung.sparkline"
    />
    <app-kpi-card
      [label]="'liveDashboard.qualitaet.kpis.untested' | translate"
      [value]="qualitaet().ungetesteteAnforderungen.value"
      icon="close"
      iconColorVar="--to-chart-failed"
      [sparkline]="qualitaet().ungetesteteAnforderungen.sparkline"
    />
    <app-kpi-card
      [label]="'liveDashboard.qualitaet.kpis.automation' | translate"
      [value]="automationValue()"
      suffix="%"
      icon="settings"
      iconColorVar="--to-purple-icon"
      [sparkline]="qualitaet().automatisierungsQuote.sparkline"
    />
    <app-kpi-card
      [label]="'liveDashboard.qualitaet.kpis.reuse' | translate"
      [value]="reuseValue()"
      suffix="×"
      [suffixAria]="'liveDashboard.qualitaet.kpis.reuseAriaSuffix' | translate"
      icon="content_copy"
      iconColorVar="--to-brand"
      [sparkline]="qualitaet().wiederverwendungsGrad.sparkline"
    />
  </div>

  <div class="quality__cards">
    <app-testmodule-stats-card [module]="qualitaet().module" />
    <app-testschritte-stats-card [schritte]="qualitaet().schritte" />
  </div>
</div>
